import {GIFT_CARDS_ENABLED} from "../actions/giftCards";

const initialState = {
  giftCards: {
    giftCardsEnabled: false
  }
};

const giftCardsEnabled = (state = initialState.giftCards, action) => {
  switch (action.type) {    
    case GIFT_CARDS_ENABLED:
      return {...state, ...{giftCardsEnabled: true}};
    default:
      return state;
  }
};

export default giftCardsEnabled;


// WEBPACK FOOTER //
// ./src/reducers/giftCards.js